import { useNavigate } from "react-router-dom";
import { useTranslation } from "@fmc-digital/i18n";
import { Button, cn } from "@fmc-digital/ui";
import { FeedbackIcon } from "@profile/components/registration-wizard/icons/FeedbackIcon";
import { getRegisterFeedbackExitNavigation } from "@profile/components/registration-wizard/feedback/register-feedback.navigation";
import {
  registrationFeedbackThankYouActionsStyles,
  registrationFeedbackThankYouCloseButtonStyles,
  registrationFeedbackThankYouContentStyles,
  registrationFeedbackThankYouCopyStyles,
  registrationFeedbackThankYouIconStyles,
  registrationFeedbackThankYouMessageStyles,
  registrationFeedbackThankYouRootStyles,
  registrationFeedbackThankYouTitleStyles,
} from "./registration-feedback-thank-you.styles";

export interface RegistrationFeedbackThankYouProps {
  username?: string;
}

export function RegistrationFeedbackThankYou({
  username,
}: Readonly<RegistrationFeedbackThankYouProps>) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    const { route, state } = getRegisterFeedbackExitNavigation(username);
    navigate(route, state ? { state } : undefined);
  };

  return (
    <div className={cn(registrationFeedbackThankYouRootStyles())} data-testid="registration-feedback-thank-you">
      <div className={cn(registrationFeedbackThankYouContentStyles())}>
        <FeedbackIcon className={cn(registrationFeedbackThankYouIconStyles())} />
        <div className={cn(registrationFeedbackThankYouCopyStyles())}>
          <h2 className={cn(registrationFeedbackThankYouTitleStyles())}>
            {t("auth.registration.feedback.thankYou.title")}
          </h2>
          <p className={cn(registrationFeedbackThankYouMessageStyles())}>
            {t("auth.registration.feedback.thankYou.message")}
          </p>
        </div>
      </div>
      <div className={cn(registrationFeedbackThankYouActionsStyles())}>
        <Button
          variant="filled"
          fullWidth
          className={cn(registrationFeedbackThankYouCloseButtonStyles())}
          onClick={handleClose}
          data-testid="feedback-thank-you-close-button"
          aria-label={t("auth.registration.feedback.thankYou.closeAriaLabel")}
        >
          {t("auth.registration.feedback.thankYou.close")}
        </Button>
      </div>
    </div>
  );
}
